import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  deleteTraininghistory,
  getTraininghistory,
} from "../../../../services/TraininghistoryService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const TraininghistoryList = () => {
  const [traininghistory, setTraininghistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchTraininghistory();
  }, []);

  const fetchTraininghistory = async () => {
    try {
      const data = await getTraininghistory();
      setTraininghistory(data);
    } catch (error) {
      console.error("Error fetching traininghistory:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteTraininghistory(id);
      fetchTraininghistory(); // Refresh list after deletion
      console.log("Traininghistory deleted successfully");
    } catch (error) {
      console.error("Error deleting traininghistory:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "employeeName", title: "Label" },
    { prop: "employeeEmail", title: "Value" },
    { prop: "trainingDate", title: "Training Date" },
    { prop: "isApproved", title: "Approved" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={"/settings/traininghistory/edit/" + row._id}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = traininghistory.map((traininghistory) => ({
    employeeName: traininghistory.employeeName,
    employeeEmail: traininghistory.employeeEmail,
    trainingDate: moment(traininghistory.trainingDate).format("YYYY-MM-DD"),
    isApproved: (traininghistory.isApproved == 'true' || traininghistory.isApproved == true) ? 'Approved' : 'Rejected',
    createdAt: moment(traininghistory.createdAt).format("YYYY-MM-DD"),
    updatedAt: moment(traininghistory.updatedAt).format("YYYY-MM-DD"),
    _id: traininghistory._id, // Include for delete/edit actions
  }));

  // Filter the data based on the traininghistory label
  const filteredData = tableData.filter(
    (item) =>
      item.employeeEmail.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Training History List</h4>
            <Link
              variant="primary"
              to={"/settings/traininghistory/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Training History</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Employee Email"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default TraininghistoryList;
